var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":function($event){$event.preventDefault();return _vm.submit()}}},[_c('svg',{staticClass:"heart",class:{ 'active': _vm.isLoved }},[_c('use',{attrs:{"xlink:href":"#heart"}})]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.loves.length))])])
}
var staticRenderFns = []

export { render, staticRenderFns }